import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { APP_ROUTES } from "@/routes/routeObjects";
import { CurrentRouteFallback } from "@/routes/routeFallbacks";

export const AppRoutes = () => {
  const element = useRoutes(APP_ROUTES);

  return <Suspense fallback={<CurrentRouteFallback />}>{element}</Suspense>;
};
